import { useEffect, useState } from 'react';
import { getCare } from './api';
import SectionHeader from './SectionHeader';

const CARE_ICONS = {
  'Купание': '🛁',
  'Стрижка': '✂️',
  'Чистка зубов': '🪥',
  'Чистка ушей': '👂',
  'Стрижка ногтей': '💅',
};

function careIcon(type) {
  return CARE_ICONS[type] || '✨';
}

export default function CareBlock({ petId, pdfPath, pdfName, docs, onDocsClick }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCare(petId)
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, [petId]);

  if (loading) return null;

  return (
    <section className="card-section" id="section-care">
      <SectionHeader
        title="Уход"
        pdfPath={pdfPath}
        pdfName={pdfName}
        periodMode="days_years"
        sectionKey="care"
        docs={docs}
        onDocsClick={onDocsClick}
      />
      {data.length === 0 ? (
        <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Нет данных</p>
      ) : (
        data.map((item) => (
          <div key={item.care_type} className="info-row">
            <span className="info-label">{careIcon(item.care_type)} {item.care_type}</span>
            <span className="info-value">{item.last_date}</span>
          </div>
        ))
      )}
    </section>
  );
}
